<template>
  <div
    class="slideshow-container"
    @pointerdown="handlePointerDown"
    @pointermove="handlePointerMove"
    @pointerup="handlePointerUp"
  >
    <div
      class="slideshow-slide"
      v-for="(slide, index) in slides"
      :key="index"
      :class="{ active: currentSlide === index }"
    >
      <FotoMetTekst
        :title="slide.title"
        :imageSrc="slide.imageSrc"
        :imageAlt="slide.imageAlt"
      />
    </div>
    <button
      v-if="!isMobile"
      class="slideshow-button slideshow-prev"
      @click="prevSlide"
    >
      ❮
    </button>
    <button
      v-if="!isMobile"
      class="slideshow-button slideshow-next"
      @click="nextSlide"
    >
      ❯
    </button>
    <div class="slideshow-indicators">
      <span
        v-for="(slide, index) in slides"
        :key="'indicator-' + index"
        class="slideshow-indicator"
        :class="{ active: currentSlide === index }"
        @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>

<script>
import FotoMetTekst from "./foto-met-tekst.vue";

export default {
  name: "Slideshow",
  components: {
    FotoMetTekst,
  },
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentSlide: 0,
      startX: 0,
      currentX: 0,
      isDragging: false,
      isMobile: false,
    };
  },
  created() {
    this.isMobile = window.innerWidth <= 767;
    window.addEventListener("resize", this.updateIsMobile);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateIsMobile);
  },
  methods: {
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    },
    prevSlide() {
      this.currentSlide =
        (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    handlePointerDown(event) {
      this.startX = event.clientX || event.touches[0].clientX;
      this.isDragging = true;
    },
    handlePointerMove(event) {
      if (!this.isDragging) return;

      this.currentX = event.clientX || event.touches[0].clientX;
    },
    handlePointerUp(event) {
      if (!this.isDragging) return;

      this.isDragging = false;
      const endX = event.clientX || event.changedTouches[0].clientX;
      const diffX = this.startX - endX;

      if (Math.abs(diffX) > 50) {
        if (diffX > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 767;
    },
  },
};
</script>

<style scoped>
.slideshow-container {
  position: relative;
  width: 100%;
  max-width: 450px;
  margin: auto;
  overflow: hidden;
  touch-action: pan-y;
}

.slideshow-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease-in-out, visibility 0s 0.5s;
}

.slideshow-slide:nth-child(1) {
  display: block;
}

.slideshow-slide.active {
  position: relative;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s ease-in-out, visibility 0s 0s;
}

.slideshow-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 1.5rem;
  z-index: 2;
}

.slideshow-prev {
  left: 0;
}

.slideshow-next {
  right: 0;
}

.slideshow-indicators {
  text-align: center;
  margin-top: 10px;
}

.slideshow-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background-color: gray;
  border-radius: 50%;
  cursor: pointer;
}

.slideshow-indicator.active {
  background-color: black;
}

@media (max-width: 767px) {
  .slideshow-button {
    display: none;
  }
}
</style>
